import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

const FlagMostrarSoloCerradasFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Row>
      <Col md={12} className='pt-2'>
        <Field name='flagMostrarSoloCerradas'>
          {({ field }) => (
            <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagMostrarSoloCerradas' label='Solo Completas' />
          )}
        </Field>
      </Col>
    </Row>
  )
}

export default React.memo(FlagMostrarSoloCerradasFormGroup)
